module.exports = __webpack_public_path__ + "img/swipre_03.e40aaff5.jpg";